import React, { useState, useEffect } from "react";
import "./style.css";
import { useNavigate } from "react-router-dom";
import { imageBaseurl, postType } from "../../common";
import apiClient from "../../apiClient";

const pageLengthArray = [10, 20, 30, 50, 70, 100, 500];

const LandingPageList = () => {
  const [JobList, setJobList] = useState([]);
  const [page, setPage] = useState(1);
  const [pageLength, setPageLength] = useState(10);
  const navigate = useNavigate();
  const [status, setStatus] = useState("1");
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
const [search, setSearch] = useState("");
const [category, setCategory] = useState("");
const [subCategory, setSubCategory] = useState("");

  const categoryData = [
    {
      name: "Calculator",
      value: "calculators"
    },
    {
      name: "PDF Tools",
      value: "pdf-tools"
    },
    {
      name: "Image Tools",
      value: "image-tools"
    },
  ]

  const subCategoryData = {
    calculators: [
      { name: "Sip Calculator", value: "sip-calculator" },
      { name: "Step Up Sip Calculator", value: "step-up-sip-calculator" },
      { name: "Lumpsum Calculator", value: "lumpsum-calculator" },
      { name: "Fd Calculator", value: "fd-calculator" },
      { name: "Rd Calculator", value: "rd-calculator" },
      { name: "Ppf Calculator", value: "ppf-calculator" },
      { name: "Epf Calculator", value: "epf-calculator" },
      { name: "Nps Calculator", value: "nps-calculator" },
      { name: "Cagr Calculator", value: "cagr-calculator" },
      { name: "Inflation Calculator", value: "inflation-calculator" },
      { name: "Swp Calculator", value: "swp-calculator" },
      { name: "Emi Calculator", value: "emi-calculator" },
      { name: "Home Loan Emi Calculator", value: "home-loan-emi-calculator" },
      { name: "Personal Loan Emi Calculator", value: "personal-loan-emi-calculator" },
      { name: "Car Loan Emi Calculator", value: "car-loan-emi-calculator" },
      { name: "Education Loan Emi Calculator", value: "education-loan-emi-calculator" },
      { name: "Simple Interest Calculator", value: "simple-interest-calculator" },
      { name: "Compound Interest Calculator", value: "compound-interest-calculator" },
      { name: "Percentage Calculator", value: "percentage-calculator" },
      { name: "Age Calculator", value: "age-calculator" },
      { name: "Bmi Calculator", value: "bmi-calculator" },
      { name: "Date Difference Calculator", value: "date-difference-calculator" },
      { name: "Time Duration Calculator", value: "time-duration-calculator" },
      { name: "Fuel Cost Calculator", value: "fuel-cost-calculator" },
    ],

    "pdf-tools": [
      { name: "Merge Pdf", value: "merge-pdf" },
      { name: "Split Pdf", value: "split-pdf" },
      { name: "Pdf To Jpg", value: "pdf-to-jpg" },
      { name: "Pdf To Png", value: "pdf-to-png" },
      { name: "Image To Pdf", value: "image-to-pdf" },
      { name: "Rotate Pdf", value: "rotate-pdf" },
      { name: "Reorder Pdf", value: "reorder-pdf" },
      { name: "Remove Pdf Pages", value: "remove-pdf-pages" },
      { name: "Extract Pdf Pages", value: "extract-pdf-pages" },
    ],

    "image-tools": [
      { name: "Image Compressor", value: "image-compressor" },
      { name: "Image Resizer", value: "image-resizer" },
      { name: "Image Converter", value: "image-converter" },
      { name: "Image Cropper", value: "image-cropper" },
      { name: "Webp Converter", value: "webp-converter" },
      { name: "Reduce Image Size", value: "reduce-image-size" },
      { name: "Image To Base64", value: "image-to-base64" },
      { name: "Image Color Picker", value: "image-color-picker" },
    ],
  };
useEffect(() => {
  getAllJobs();
}, [page, pageLength, status, search, category, subCategory]);

 const getAllJobs = async () => {
  try {
    const response = await apiClient.get(
      `/landing?page=${page}&limit=${pageLength}&status=${status}&search=${search}&category=${category}&subCategory=${subCategory}`
    );

    setJobList(response.data.data.data);
    setTotalPages(response.data.data.totalPages);
    setTotalCount(response.data.data.totalCount);
  } catch (error) {
    console.error("Error fetching jobs:", error);
  }
};

  const routeChange = (path) => {
    navigate(path);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <div className="container my-5">
      <div className="card shadow-lg">
        <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
          <h3 className="mb-0">Landing Page List </h3>
          <span>
          Total Landing Page  : {totalCount}
          <br />
          Total Page : {totalPages}
          </span>
          <button
            className="btn btn-success"
            onClick={() => routeChange('/landing/add')}
          >
            Add New Landing Page 
          </button>
        </div>
        <div className="card-body">
       <div className="row mb-4 g-3">

  {/* Search */}
  <div className="col-md-3">
    <input
      type="text"
      className="form-control form-control-lg"
      placeholder="Search title or slug"
      value={search}
      onChange={(e) => {
        setSearch(e.target.value);
        setPage(1);
      }}
    />
  </div>

  {/* Status */}
  <div className="col-md-2">
    <select
      className="form-control form-control-lg"
      value={status}
      onChange={(e) => {
        setStatus(e.target.value);
        setPage(1);
      }}
    >
      <option value="">Select Status</option>
      <option value="0">Inactive</option>
      <option value="1">Active</option>
    </select>
  </div>
{/* Category */}
  <div className="col-md-2">
    <select
      className="form-control form-control-lg"
      value={category}
      onChange={(e) => {
        setCategory(e.target.value);
        setSubCategory("");
        setPage(1);
      }}
    >
      <option value="">All Categories</option>

      {categoryData.map((item) => (
        <option key={item.value} value={item.value}>
          {item.name}
        </option>
      ))}
    </select>
  </div>

  {/* Sub Category */}
  <div className="col-md-2">
    <select
      className="form-control form-control-lg"
      value={subCategory}
      onChange={(e) => {
        setSubCategory(e.target.value);
        setPage(1);
      }}
      disabled={!category}
    >
      <option value="">All Sub Categories</option>

      {category &&
        subCategoryData[category]?.map((item) => (
          <option key={item.value} value={item.value}>
            {item.name}
          </option>
        ))}
    </select>
  </div>

  {/* Page Length */}
  <div className="col-md-2">
    <select
      className="form-control form-control-lg"
      value={pageLength}
      onChange={(e) => {
        setPage(1);
        setPageLength(Number(e.target.value));
      }}
    >
      {pageLengthArray.map((res) => (
        <option key={res} value={res}>
          {res}
        </option>
      ))}
    </select>
  </div>

</div>

          {JobList.length === 0 ? (
            <div className="text-center py-4">
              <p className="text-muted">No posts found.</p>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover table-bordered">
                <thead className="table-primary">
                  <tr>
                    <th className="text-center">#</th>
                    <th>Title</th>
                    <th>Slug</th>
                    <th>Sub Category</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {JobList.map((res, index) => (
                    <tr key={res.postId} className="align-middle">
                      <td className="text-center">{(page - 1) * pageLength + index + 1}</td>
                      <td>{res?.pageTitle}</td>
                      <td>{res?.pageSlug}</td>
                      <td>
                        {res?.subCategory}
                      </td>
                      <td>
                        <span
                          className={`badge ${
                            res.status == "1" ? "bg-success" : "bg-danger"
                          }`}
                        >
                          {res.status == "1" ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td>
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => routeChange(`/landing/edit/${res.id}`)}
                        >
                          Edit
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Pagination */}
          <nav aria-label="Page navigation">
           
            <ul className="pagination justify-content-center mt-4">
              <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                <button
                  className="page-link"
                  onClick={() => handlePageChange(page - 1)}
                  disabled={page === 1}
                >
                  Previous
                </button>
              </li>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
                <li
                  key={p}
                  className={`page-item ${page === p ? "active" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(p)}
                    style={{ cursor: "pointer" }}
                  >
                    {p}
                  </button>
                </li>
              ))}
              <li className={`page-item ${page >= totalPages ? "disabled" : ""}`}>
                <button
                  className="page-link"
                  onClick={() => handlePageChange(page + 1)}
                  disabled={page === totalPages}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default LandingPageList;